import { File as FileDisplay } from '@ingeniorforeningen/figurine-core';
import { TFile, Errors, FileUploaderErrorCodes } from '../../../types';
import { useFileUpload } from '../../../hooks';

type FileProps = {
  item: TFile;
  errorTexts: Errors;
  setAppendDocument: (fileUploadId: string, filename: string) => void;
  removeFileUploadId: (fileUploadId: string) => void;
  removeFile: (id: string) => void;
};

const File = ({
  item,
  errorTexts,
  setAppendDocument,
  removeFileUploadId,
  removeFile,
}: FileProps) => {
  const {
    isFileUploaded,
    fileUploadError,
    fileUploadPercentage,
    handleFileUpload,
    handleFileRemoveClick,
  } = useFileUpload(item, errorTexts, setAppendDocument, removeFileUploadId, removeFile);

  const showRetryButton =
    fileUploadError?.errorCode !== FileUploaderErrorCodes.BAD_REQUEST &&
    fileUploadError?.errorCode !== FileUploaderErrorCodes.FILE_TOO_LAGE;

  const handleRetryFileUpload = async () => {
    await handleFileUpload(item);
  };

  return (
    <FileDisplay
      cypress="fileDisplay"
      key={item.id}
      filename={item.file.name}
      isFileUploaded={isFileUploaded}
      uploadPercentage={fileUploadPercentage}
      onClick={handleFileRemoveClick}
      handleRetryFileUpload={handleRetryFileUpload}
      errorMessage={fileUploadError?.errorMessage}
      showRetryButton={showRetryButton}
    />
  );
};

export default File;
